import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/styles'
import React, { useState } from 'react'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'
import moment from 'moment'
import callServer from '../../../../api/callServer'
import AppButton from '../../../../commonComponents/AppButton'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2,
  height: '90vh',
  overflowY: 'auto',
  width: '70%'
}

const responsiveStyle = {
  position: 'absolute',
  transform: 'translate(-0%, -0%)',
  bgcolor: 'background.paper',
  p: 2,
  height: '100%',
  overflowY: 'auto',
  width: '100%'
}

export default function ViewApplicationModal ({ data, matches }) {
  var { open, item, onClose } = data
  const [progress, setProgress] = useState(0)
  const [progressCover, setProgressCover] = useState(0)

  const theme = useTheme()

  const handleDownload = async (file, type) => {
    let fileName = `${item?.candidateFirstName}${
      item?.candidateLastName
    }${type}.${file.split('.').pop()}`
    callServer.downloadFile(file, fileName, percentCompleted => {
      setProgress(percentCompleted === 100 ? 0 : percentCompleted)
    })
  }
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={matches ? responsiveStyle : style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: matches ? 16 : 4,
            top: matches ? 16 : 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Typography
          id='modal-modal-description'
          sx={{ mt: 2 }}
          style={{ whiteSpace: 'pre-line' }}
        >
          <Grid container style={{ paddingRight: '16px' }}>
            <Grid container direction={'row'} style={{ margin: '16px' }}>
              <Grid
                item
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  border: `1px solid ${theme.palette.border.main}`,
                  width: '89px',
                  height: '88px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  padding: '8px',
                  alignItems: 'center'
                }}
              >
                <TextRegular
                  style={{
                    fontSize: '32px'
                  }}
                >
                  {item?.candidateFirstName.substring(0, 1).toUpperCase()}
                  {item?.candidateLastName.substring(0, 1).toUpperCase()}
                </TextRegular>
              </Grid>

              <Grid item xs={8}>
                <Grid container style={{ paddingLeft: '16px' }}>
                  <Grid item xs={12} style={{ marginBottom: 8 }}>
                    <TextBold
                      style={{
                        fontSize: '18px'
                      }}
                    >
                      {item?.candidateFirstName} {item?.candidateLastName}
                    </TextBold>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: 4 }}>
                    <TextRegular
                      style={{
                        fontSize: '16px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item?.candidateEmail}
                    </TextRegular>
                    {!item.isRegistered && (
                      <TextRegular
                        style={{
                          fontStyle: 'italic',
                          fontSize: '16px',
                          color: theme.palette.text.secondary
                        }}
                      >
                        (Unregistered)
                      </TextRegular>
                    )}
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0px' }}>
                    <TextRegular
                      style={{
                        fontSize: '16px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item?.candidatePhone}
                    </TextRegular>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ display: 'flex', justifyContent: 'right' }}>
                <TextRegular style={{ color: theme.palette.text.secondary }}>
                  Applied on: {moment(item?.createdAt).fromNow()}
                </TextRegular>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item style={{ margin: '16px' }}>
                  <AppButton
                    name={
                      progress > 0
                        ? `Downloading: ${progress}%`
                        : 'Download resume'
                    }
                    fullWidth={false}
                    onClick={() => {
                      let file = item.resumePath
                      let fileName = `${item?.candidateFirstName}${
                        item?.candidateLastName
                      }Resume.${file.split('.').pop()}`
                      callServer.downloadFile(
                        file,
                        fileName,
                        percentCompleted => {
                          setProgress(
                            percentCompleted === 100 ? 0 : percentCompleted
                          )
                        }
                      )
                    }}
                  />
                </Grid>

                <Grid
                  item
                  style={{ margin: matches ? '0px 16px' : '16px 0px' }}
                >
                  {item?.coverLetterPath && (
                    <AppButton
                      name={
                        progressCover > 0
                          ? `Downloading: ${progressCover}%`
                          : 'Download cover letter'
                      }
                      fullWidth={false}
                      onClick={() => {
                        let file = item.coverLetterPath
                        let fileName = `${item?.candidateFirstName}${
                          item?.candidateLastName
                        }Cover.${file.split('.').pop()}`
                        callServer.downloadFile(
                          file,
                          fileName,
                          percentCompleted => {
                            setProgressCover(
                              percentCompleted === 100 ? 0 : percentCompleted
                            )
                          }
                        )
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            {item?.coverSummary && (
              <Grid
                item
                xs={12}
                style={{
                  margin: '16px 0px 16px 16px',
                  border: `1px solid ${theme.palette.border.main}`
                }}
              >
                <Grid container style={{ marginBottom: '16px' }}>
                  <Grid item xs={12} style={{ margin: '16px' }}>
                    <TextBold style={{ fontSize: '16px' }}>Summary :</TextBold>
                  </Grid>
                  <Grid item xs={12} style={{ marginLeft: '16px' }}>
                    <TextRegular>
                      <Box
                        dangerouslySetInnerHTML={{
                          __html: item?.coverSummary
                        }}
                      />
                    </TextRegular>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              style={{
                margin: '16px 0px 16px 16px'
              }}
            >
              <Divider
                style={{
                  width: '100%'
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                margin: '10px 0px 16px 16px'
              }}
            >
              <Grid container style={{ marginBottom: '16px' }}>
                <Grid item xs={12} style={{ marginBottom: '16px' }}>
                  <TextBold style={{ fontSize: '16px' }}>
                    Pre-screen questionnaire
                  </TextBold>
                </Grid>
                <Grid item xs={12}>
                  {item?.preScreenQuestions?.map((queAns, index) => (
                    <Grid key={index} container>
                      <Grid item xs={12} style={{ display: 'flex' }}>
                        <Grid
                          item
                          style={{
                            background: theme.palette.border.main,
                            padding: '8px 16px',
                            borderRadius: '10px',
                            width: '200px',
                            display: 'flex',
                            justifyContent: 'center'
                          }}
                        >
                          <TextBold>Employer Question:</TextBold>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginLeft: '10px',
                            width: '75%'
                          }}
                        >
                          <TextBold>{queAns?.question}</TextBold>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} style={{ display: 'flex' }}>
                        <Grid
                          item
                          style={{
                            background: theme.palette.border.main,
                            padding: '8px 16px',
                            borderRadius: '10px',
                            margin: '10px 0px',
                            width: '200px',
                            display: 'flex',
                            justifyContent: 'center'
                          }}
                        >
                          <TextRegular>Candidate answer:</TextRegular>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginLeft: '10px',
                            width: '75%'
                          }}
                        >
                          <TextRegular>{queAns?.answer}</TextRegular>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  )
}
